/* eslint-disable import/no-cycle */
import { AxiosInstance } from 'axios'

import { PTPService } from '../../@types/ptp-service'

export enum CallLogActionCodes {
    'None' = 'None',
    'PTP' = 'PTP', // Promise To Pay
    'CT' = 'CT', // Call Touched
    'CB' = 'CB', // Call Back
    'RTC' = 'RTC', // <unused>
    'CBCC' = 'CBCC', // Called but Cannot Contact
    'VM' = 'VM', // Voice Mail
    'WN' = 'WN', // Wrong Number
    'OUT' = 'OUT', // <unused>
    'OP' = 'OP', // Others Picked Up
    'NOT' = 'NOT', // Not in Service
    'NEX' = 'NEX', // Number Does Not Exist
    'NW' = 'NW', // Call Touched but This Person does not Work Here
    'DW' = 'DW', // Call Touched but This Person No Longer Works Here
    'WRN' = 'WRN', // Wrong Reference Number given
}

export default (api: AxiosInstance) => ({
    async checkCID(cid: string) {
        try {
            const result = await api.post<PTPService.CheckCIDResponse>(
                '/customer/ptp-verification',
                {
                    cid,
                }
            )
            return result.data
        } catch (error) {
            throw error.response
        }
    },

    async getCustomerDpd(pinUsername: string) {
        try {
            const result = await api.get<PTPService.CustomerDpdResponse>(
                `/customer-dpd?pinUsername=${pinUsername}`
            )
            return result.data
        } catch (error) {
            throw error.response
        }
    },

    async submitForm(formData: PTPService.PersonalInfoFormPayload, uid: string) {
        try {
            const result = await api.post(`/customer/ptp-submit?uid=${uid}`, {
                actionCode: CallLogActionCodes.PTP,
                actionBy: 'LINE',
                actionDate: new Date(),
                createdDate: new Date(),
                note: formData.note,
                partyId: formData?.pinUsername ?? formData?.partyId ?? null,
                summary: 'สัญญาว่าจะชำระเงิน',
                createdBy: 'Thunder Connect',
                contactNumber: formData.contactNumber,
                ptpDate: formData.ptpDate,
                ptpAmount: formData.ptpAmount,
            } as PTPService.PersonalInfoFormRequest)
            return result.data
        } catch (error) {

            const body = error.response?.data || {}
            throw new Error(
                body.details?.error || body?.message || body?.error || 'Something went wrong.'
            )
        }
    },
})
